import React, { useState } from 'react';
import { Dropdown } from 'semantic-ui-react';
import RemovalConfirmation from './RemovalConfirmation';

const AssignmentWithRemoval = (props) => {
  const [open, setOpen] = useState(false);
  const [dropdownEvent, setDropdownEvent] = useState({});

  const onDropdownChange = (event, data) => {
    if (data.value === 'Remove Patient Encounter') {
      setDropdownEvent({
        event,
        data,
      });
      setOpen(true);
    } else {
      props.handleTeammateChange(event, data);
    }
  };

  const handleQueueUpdate = () => {
    if (props.queueState && props.queueState.queue) {
      const filteredQueue = props.queueState.queue.filter(
        (encounter, index) => {
          return encounter.admission_id !== props.admissionId;
        }
      );

      props.setQueueState((prev) => ({
        ...prev,
        queue: filteredQueue,
      }));
    }
  };

  return (
    <React.Fragment>
      {props.showLabel ? (
        <span style={{ paddingRight: '15px' }}>
          <strong>Assigned To: </strong>
          <Dropdown
            options={props.options}
            className='cb-assignment'
            data-entity-id={props.entityId}
            data-admission-id={props.admissionId}
            placeholder='Assign To'
            selection
            value={props.assignedUser ? props.assignedUser : ''}
            onChange={(event, data) => onDropdownChange(event, data)}
            style={props.style}
            selectOnBlur={false}
          />
        </span>
      ) : (
        <Dropdown
          options={props.options}
          className='cb-assignment'
          data-entity-id={props.entityId}
          data-admission-id={props.admissionId}
          placeholder='Assign To'
          selection
          value={props.assignedUser ? props.assignedUser : ''}
          onChange={(event, data) => onDropdownChange(event, data)}
          fluid
          style={props.style}
          selectOnBlur={false}
        />
      )}

      <RemovalConfirmation
        open={open}
        setOpen={setOpen}
        patientName={props.patientName}
        handleTeammateChange={props.handleTeammateChange}
        dropdownEvent={dropdownEvent}
        handleQueueUpdate={handleQueueUpdate}
      />
    </React.Fragment>
  );
};

export default AssignmentWithRemoval;
